import { Alert, Snackbar } from "@mui/material";
import React, { useState } from "react";

 const SnackBar  = (props) => {

    // message needs to be display on snackbar

    let  {
      open,
      message,
      onClose,
      severity = 'success',
      elevation = 6,
      variant = 'outlined',
      autoHideDuration = 6000,
      transitionComponent = 'SlideTransition'
  } = props;

    // snackbar anchor 
    let anchorStyle = {
        vertical: 'top',
        horizontal: 'center',
    }

    const AlertStyle = ()=>{
        if(severity == "success"){
             return {width: '100%',
                     color: '#008757',
                     borderColor: '#008757',
                     fontFamily: 'Avenir',
                     fontSize: '14px',
                     fontStyle: 'normal',
                     margin: '10px',
                     marginTop:'115px',
                     background: '#fff'}       
             }
         if(severity == "error"){

            return {width: '100%',
                    color: '##DE3412',
                    borderColor: '##DE3412',
                    fontFamily: 'Avenir',
                    fontSize: '14px',
                    fontStyle: 'normal',
                    margin: '10px', 
                    marginTop:'115px',
                    background: '#fff'}       
            }

            return {width: '100%',
                    color: '#000000',
                    borderColor: '#000000',
                    fontFamily: 'Avenir',
                    fontSize: '14px',
                    fontStyle: 'normal',
                    margin: '10px',
                    marginTop:'115px',
                    background: '#fff'}       
            }

    return <div style={{marginTop: 50}} >
         <Snackbar 
             variant="small"
             anchorOrigin={anchorStyle}
             open={open}
             autoHideDuration={autoHideDuration}
             onClose={onClose}
             elevation={elevation}
             >
                <Alert 
                    severity={severity}
                    variant={variant} 
                    sx={AlertStyle}
                     >
                    {message}
                </Alert> 
         </Snackbar>
         </div>

}

export default SnackBar;